module.exports = __webpack_public_path__ + "static/media/architecture-building-city-2047397.44e1602b.png";